'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _join = require('../../utils/join');

var _join2 = _interopRequireDefault(_join);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClassName(_ref) {
  var props = _ref.props,
      _ref$state = _ref.state,
      state = _ref$state === undefined ? {} : _ref$state;
  var listPosition = props.listPosition,
      _props$data = props.data,
      data = _props$data === undefined ? [] : _props$data,
      className = props.className,
      rootClassName = props.rootClassName,
      loading = props.loading,
      relativeToViewport = props.relativeToViewport;
  var succesfullPosition = state.succesfullPosition;


  var constructedClassName = (0, _join2.default)(rootClassName, className, listPosition && rootClassName + '--' + listPosition, loading && rootClassName + '--loading', relativeToViewport && rootClassName + '--relative-to-viewport', data && !data.length && rootClassName + '--empty');

  if (succesfullPosition) {
    var positionName = succesfullPosition === 'bc-tc' ? 'top' : 'bottom';
    constructedClassName = (0, _join2.default)(constructedClassName, rootClassName + '--position-' + positionName);
  }

  return constructedClassName;
} /**
   * Copyright (c) 2015-present, Zippy Technologies
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

exports.default = getClassName;